import { Box, Flex, Text, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'
import Link from 'next/link'

const Products = () => {
  return (
    <Box h="100%">
      <Flex
        h="100%"
        direction={['column', 'column', 'row']}
        justifyContent="center"
        alignItems="stretch"
        gap={['50px', '50px', '20px']}
        py="50px"
      >
        <Flex direction="column" alignItems="center" gap="20px" flex={1}>
          <Flex w="308px" h="383px" alignItems="end" justifyContent="center">
            <Box w="130px" h="280px">
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/product-1-1736490982900.png"
                alt="zero-2-one"
                width={160}
                height={250}
                className="w-full h-full object-cover"
              />
            </Box>
          </Flex>

          <Flex direction="column" gap="10px">
            <Box>
              <Text color={COLOR.YELLOW} fontWeight="bold" fontSize="xl">
                Zero2One 10ml Travel
              </Text>

              <Text mt={1} color={COLOR.LIGHT} fontWeight="bold">
                $39.90
              </Text>
            </Box>
            <Text mt={1} color={COLOR.LIGHT}>
              Therapy while on the go. <br /> Refillable from larger size.
            </Text>
          </Flex>

          <Flex flex={1}>
            <Link
              href="https://habbit.sg/products/zero2one-hair-tonic-by-ellixi-plus"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto"
            >
              <Box w="148px" h="40px">
                <AspectRatio ratio={37 / 10} w="100%">
                  <Image
                    src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1736933425040.png"
                    alt="zero-2-one button"
                    fill
                  />
                </AspectRatio>
              </Box>
            </Link>
          </Flex>
        </Flex>

        <Flex direction="column" alignItems="center" gap="20px" flex={1}>
          <Flex w="308px" h="383px" alignItems="center" justifyContent="center">
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/product-2-1736490982901.png"
              alt="zero-2-one"
              width={308}
              height={383}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Flex>

          <Flex direction="column" gap="10px">
            <Box flex={1}>
              <Text color={COLOR.YELLOW} fontWeight="bold" fontSize="xl">
                Zero2One 50ml Travel
              </Text>
              <Flex gap="4px">
                <Text mt={1} color={COLOR.LIGHT} fontWeight="bold">
                  $99.90
                </Text>
                <Text mt={1} color={COLOR.LIGHT} textDecoration="line-through">
                  $159.90
                </Text>
              </Flex>
            </Box>
            <Text mt={1} color={COLOR.LIGHT}>
              Up to 3 months of moderate <br /> use. Additional spray nozzle{' '}
              <br />
              for usage preference.
            </Text>
          </Flex>

          <Link
            href="https://habbit.sg/products/zero2one-hair-tonic-by-ellixi-plus"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box w="148px" h="40px">
              <AspectRatio ratio={37 / 10} w="100%" position="relative">
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/PM-1736933425040.png"
                  alt="zero-2-one button"
                  fill
                />
              </AspectRatio>
            </Box>
          </Link>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Products
